module.exports = __webpack_public_path__ + "static/media/icon_resize-.f4e6c830.svg";